<template>
  <div>
      <input class="form-control" id="address-2" ref="street2input" v-validate="'required'"  :class="{'input form-control': true, 'is-invalid form-control': errors.has('city') }" name="street2" :value="streetAddress2Val.value" @input="valUpdated()">
  </div>

</template>

<script>
import _ from 'lodash'

export default {
  name: 'StreetAddress2',
  props: {
    value: {type: undefined}
  },
  data: function () {
    return {
      location: ''
    }
  },
  created: function () {

  },
  computed: {
    streetAddress2Val: function () {
      if (!this.value) {
        return {
          value: ''
        }
      }
      let val = _.find(this.value, (v) => {
        if (v.propertyID === 'unitAddress') {
          return v
        }
      })
      if (val) {
        return val
      }
      return {
        value: ''
      }
    }
  },
  methods: {
    valUpdated: function () {
      let newlist = []
      if (this.value) {
        newlist = _.cloneDeep(this.value)
      }

      let existingProp = this.streetProp(newlist)
      if (existingProp) {
        existingProp.value = this.$refs.street2input.value
      } else {
        newlist.push(this.newProp(this.$refs.street2input.value))
      }
      this.$emit('input', newlist)
    },
    newProp: function (val) {
      let newval = {
        '@type': 'PostalAddress',
        propertyID: 'unitAddress',
        value: val
      }
      return newval
    },
    streetProp: function (props) {
      for (let prop of props) {
        if (prop.propertyID === 'unitAddress') {
          return prop
        }
      }
      return undefined
    }
  }
}
</script>



// WEBPACK FOOTER //
// street2.vue?d08ba39a